export const BREAKPOINT_LG = 1220 - 0.02;
export const BREAKPOINT_MD = 1024 - 0.02;
export const BREAKPOINT_HORIZONTAL_SMARTPHONE = 897 - 0.02;
export const BREAKPOINT_SM = 576 - 0.02;
